import { render, staticRenderFns } from "./SelectInputSelectedItem.vue?vue&type=template&id=bd859bcc&scoped=true&"
import script from "./SelectInputSelectedItem.vue?vue&type=script&lang=js&"
export * from "./SelectInputSelectedItem.vue?vue&type=script&lang=js&"
import style0 from "./SelectInputSelectedItem.vue?vue&type=style&index=0&id=bd859bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd859bcc",
  null
  
)

export default component.exports